module.exports = __webpack_public_path__ + "img/partners9.743f8f65.png";